import React from 'react';
import PropTypes from 'prop-types';
import * as Logos from './images';

const COLORS = {
  black: '#000000',
  white: '#FFFFFF',
  altoLight: '#d8d8d8',
};

const Social = ({ brand = null, color = 'white' }) => {
  if (!brand) return null;
  const logoColor = COLORS[color];
  const Component = Logos[brand] || null;
  return Component ? (
    <Component
      style={{ height: '100%', width: '100%' }}
      color={logoColor}
      data-test={`${brand}-social`}
    />
  ) : null;
};

Social.propTypes = {
  brand: PropTypes.string,
  color: PropTypes.string,
};

Social.defaultProps = {
  color: 'white',
  brand: null,
};

export default Social;
